import React from "react";

import { Toggle } from "../../../component-library";

import "./styles.scss";

// NOTE: THIS PATTERN WAS COPIED FROM the care management form
export const WaitlistFormToggle = ({ formikProps, name }) => {
  const isToggled = formikProps.values[name];

  const handleChange = async () => {
    await formikProps.setFieldValue(name, !isToggled);
  };

  return <Toggle checked={isToggled} name={name} onClick={handleChange} />;
};
